import { Component, Output, EventEmitter, Input } from "@angular/core";

import { BaseComponent, UserService, environment } from "@mypxplat/xplat/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "myp-cancel-subscription",
  templateUrl: "cancel-subscription.component.html",
  standalone: false,
})
export class CancelSubscriptionComponent extends BaseComponent {
  public softCanceling: boolean = false;
  public cancelReason: string;
  @Input() storageOnly: boolean;
  @Output() canceled: EventEmitter<any> = new EventEmitter();
  public loading: boolean;
  public reasonCode: any = "-1";
  public reasonCodes: Array<any> = [
    {
      code: "too_expensive",
      title: "Too expensive",
    },
    {
      code: "not_satisfied",
      title: "Not satisfied with service or features",
    },
    {
      code: "project_complete",
      title: "No longer needed/project complete",
    },
    {
      code: "support_issue",
      title: "Support issue",
    },
    {
      code: "competitor",
      title: "Leaving for a competitor",
    },
    {
      code: "other",
      title: "Other",
    },
  ];

  constructor(
    userService: UserService,
    public activeModal: NgbActiveModal
  ) {
    super(userService);
  }

  cancel() {
    if (this.storageOnly) {
      this.userService.cancelSubscription(this.userService.userSubscription.storage.provider_subscription_id).subscribe((result) => {
        this.userService.getUserDetails(false).subscribe((result) => {
          this.canceled.next(true);
          this.activeModal.close();
        });
      });
    } else if (this.reasonCode && this.reasonCode != "-1") {
      if (this.reasonCode == "other" && !this.cancelReason) {
        alert("Please enter a reason you are canceling your account.");
      } else {
        this.loading = true;
        this.userService
          .submitFeedback({
            description: this.cancelReason,
            reason_code: this.reasonCode,
            type: "cancellation",
          })
          .subscribe((result) => {
            this.userService.cancelSubscription(this.storageOnly ? this.userService.userSubscription.storage.provider_subscription_id : false).subscribe((result) => {
              this.userService.getUserDetails(false).subscribe((result) => {
                this.canceled.next(true);
                this.activeModal.close();
              });
            });
          });
      }
    } else {
      alert("Please indicate a reason why you are canceling your account. ");
    }
  }
}
